export default "__VITE_ASSET__CRMOsvbb__"